import { string } from "prop-types";

export const REDUX_CRM_COMPANIES_CONSTANTS = {
    RequestsFetchAll: "CRM_COMPANY_FETCH_ALL",
    RequestsReceiveProfile: "CRM_COMPANY_RECEIVE_ALL",
    RequestsFetchLoading: "CRM_COMPANY_FETCH_LOADING",
    RequestDetails: "CRM_COMPANY_DETAILS",
    RequestsAddNew: "CRM_COMPANY_ADD_NEW",
    RequestsPostNew: "CRM_COMPANY_POST_NEW",
    SET_SORT_PARAMS: "SET_SORT_PARAMS",
    FILTER_DATA: "FILTER_DATA",
    FILTER_RESET: "FILTER_RESET"
}

const initialState = {
    loading: false,
    data: [],
    requestDetails: undefined,
    filter: {
        isOpen: false,
        companyName: string,
        registrationNumber: string,
        incorporationDate: string
    }
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case REDUX_CRM_COMPANIES_CONSTANTS.RequestsFetchAll: {
            return {...state, loading: false, data: action.payload}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.RequestsFetchLoading: {
            return {...state, loading: action.payload}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.RequestDetails: {
            return {...state, data: action.payload}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.RequestsAddNew: {
            return {...state, addNew: action.payload}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.RequestsPostNew: {
            return {...state, data: [action.payload, ...state.data]}
        }
        
        case REDUX_CRM_COMPANIES_CONSTANTS.FILTER_DATA: {
            return {...state, filter: action.payload}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.FILTER_RESET: {
            return {...state, filter: {
                isOpen: false,
                companyName: '',
                registrationNumber: '',
                incorporationDate: ''
            }}
        }

        case REDUX_CRM_COMPANIES_CONSTANTS.RequestsReceiveProfile: {

            const existingProfile = state?.data.find((p:any) => p.id === action?.payload?.id)
            
            if (existingProfile) {
                let G = state?.data.filter((y:any) => y.id !== action?.payload?.id)
                return {...state, data: [action?.payload, ...G]}
            } else {
                let F = [action.payload, ...state.data]
                F?.pop()
                return {...state, data: [...F]}
            }
        }

        default: {
            return state
        }
    }
}
